import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { Field, Link } from '@sitecore-jss/sitecore-jss-nextjs';

import { AuthenticatedUserProfile } from 'src/types/AuthenticatedUserProfile';

import { MenuLink } from '../../../NavigationMenu';

import styles from './_PersonalisedLinks.module.css';

type PersonalisedLinksProps = {
	fields: {
		WelcomeMessage?: Field<string>;
		NonSubscriberExcludedLinks?: MenuLink[];
		RegisteredUserExcludedLinks?: MenuLink[];
		PersonalisedLinks?: MenuLink[];
	};
	showWelcomeMessage?: boolean;
	authenticatedUserProfile?: AuthenticatedUserProfile;
};

export default function PersonalisedLinks(props: PersonalisedLinksProps): JSX.Element {
	const router = useRouter();

	const [accessLevelPersonalisedLinks, setAccessLevelPersonalisedLinks] = useState<MenuLink[] | undefined>([]);

	useEffect(() => {
		setAccessLevelPersonalisedLinks(
			props.authenticatedUserProfile &&
				props.fields?.PersonalisedLinks?.filter((item: MenuLink) => {
					const url = item?.fields.Link?.value?.href;

					if (!props.authenticatedUserProfile?.isActiveRcniSubscriber) {
						return !props.fields?.NonSubscriberExcludedLinks?.map((item) => item?.fields.Link?.value?.href)?.includes(url);
					} else if (!props.authenticatedUserProfile?.isActiveMember && !props.authenticatedUserProfile?.isActiveRcniSubscriber) {
						return !props.fields?.RegisteredUserExcludedLinks?.map((item) => item?.fields.Link?.value?.href)?.includes(url);
					} else {
						return true;
					}
				})
		);
	}, [
		props.authenticatedUserProfile,
		props.fields.PersonalisedLinks,
		props.fields.NonSubscriberExcludedLinks,
		props.fields.RegisteredUserExcludedLinks,
	]);

	if (!props.authenticatedUserProfile) {
		return <></>;
	}

	function personalisedLinkActiveClass(item: MenuLink) {
		const asPath = router.asPath || '/';
		const hash = asPath.split('/');
		const pathWithoutQueries = asPath.split('?')[0].toLowerCase();
		const href = item?.fields.Link?.value.href.toLowerCase();
		const searchPath = process.env.NEXT_PUBLIC_DEFAULT_SEARCH_PATH?.toString().toLocaleLowerCase() || '/search';

		if (!item?.name || hash.length < 1) {
			return false;
		}

		if (pathWithoutQueries === href || (href?.includes(searchPath) && pathWithoutQueries?.includes(searchPath + '/'))) {
			return item?.name?.includes(hash[1]);
		}

		return false;
	}

	return (
		<>
			{props.showWelcomeMessage && (
				<h3 className={styles.heading}>
					{props.fields.WelcomeMessage?.value?.replace('$firstname$', props.authenticatedUserProfile.contact?.firstName ?? '')}
				</h3>
			)}

			{accessLevelPersonalisedLinks?.map((link) => {
				return (
					<ul key={link.id} className={styles.list}>
						<li>
							<Link
								className={`link linkOffset linkHoverWeighted linkHoverSecondary ${personalisedLinkActiveClass(link) ? 'active' : ''}`}
								field={link.fields.Link}
							/>
						</li>
					</ul>
				);
			})}
		</>
	);
}
